import axios from "axios";

export const TOKEN_KEY = "pathtel_token";

export const ptApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/pathlync`,
});

ptApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const ptError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || JSON.stringify(d)).filter(Boolean).join(" ");
  }
  return e?.message || "Something went wrong. Please try again.";
};

export const imageUrl = (id) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/pathlync/images/${id}/file`
  + `?token=${encodeURIComponent(localStorage.getItem(TOKEN_KEY) || "")}`;

export const reportPdfUrl = (consultId) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/pathlync/consults/${consultId}/report.pdf`
  + `?token=${encodeURIComponent(localStorage.getItem(TOKEN_KEY) || "")}`;
